import type { IHttpError } from '@wix/http-client';
import { HttpClient } from '@wix/http-client';
import VError from 'verror';

export function extractHttpError(error: unknown): IHttpError | null {
  if (HttpClient.isHttpError(error)) {
    return error;
  }

  const nestedError = error instanceof Error ? VError.cause(error) : null;
  return nestedError ? extractHttpError(nestedError) : null;
}
